export const ChecksFilters = {
  PRELOADCHECKS: 'preload-checks',
  ANNUALVETTINGS: 'annual-vettings',
};
